import { render, staticRenderFns } from "./addTenantPackage.vue?vue&type=template&id=d2065090"
import script from "./addTenantPackage.vue?vue&type=script&lang=js"
export * from "./addTenantPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports